import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sortResults' })
export class SortResultsPipe implements PipeTransform {

  transform(value: any, arg: any): any {
    if (value && value.length > 0 && (!value[0].hasOwnProperty('id')) && arg) {
      const keys = Object.keys(value);
      keys.forEach(key => {
        const content = value[key].content;
        content.sort((a, b) => {
          if (a[arg] > b[arg]) {
            return 1;
          } else if (a[arg] < b[arg]) {
            return -1;
          } else {
            return 0;
          }
        });
        value[key] = { ...value[key], content };
      });
      return value;
    } else if (value && value.constructor === Array && arg) {
      return (value).sort((a, b) => {
        if (a.hasOwnProperty(arg) && b.hasOwnProperty(arg)) {
          if (a[arg] < b[arg]) {
            return -1;
          } else if (a[arg] > b[arg]) {
            return 1;
          } else {
            return 0;
          }
        }
      });
    } else {
      return value;
    }
  }

}
